<template>
  <div class="col-md-11 col-lg-10 mx-auto py-2" v-if="consulto">
    <div class="col-12 text-left pb-3 px-0">
      <router-link
        :to="{ name: 'Home' }"
        class="text-left text-secondary font-weight-bold ml-2 mr-auto d-flex align-content-center"
      >
        <ArrowLeftLogo />
        <span>Torna alla home</span>
      </router-link>
    </div>
    <div v-if="!started">
      <div class="mx-auto" :class="isMobile ? 'd-flex no-wrap' : 'row'">
        <div class="col" :class="isMobile && 'px-0'">
          <h3 class="font-weight-bold text-left" v-if="isMobile">
            Il tuo consulto con
            <!-- <br /> -->
            <span
              class="text-primary font-weight-normal"
            >{{ consulto.professionista.anagrafica.fullname }}</span>
          </h3>
          <h1 v-else class="font-weight-bold">
            Il tuo consulto con
            <br />
            <span
              class="text-primary font-weight-normal"
            >{{ consulto.professionista.anagrafica.fullname }}</span>
          </h1>

          <div class="col-sm-12 col-lg-10 mx-auto pt-2">
            <b-button
              v-if="showStartBtn"
              block
              variant="primary"
              class="my-2 font-weight-bold rounded-pill py-2"
              @click="start"
            >Avvia videochiamata</b-button>
            <h5 v-else class="text-center text-secondary font-weight-bold text-capitalize">
              <span v-if="minutesLefts >=0">{{ consulto.data_inizio | moment("dddd D MMMM HH:mm") }}</span>
              <span v-else>{{minutesLefts + " minuti al teleconsulto" }}</span>
            </h5>
          </div>
        </div>

        <div :class="isMobile ? 'col-4' : 'col-5'">
          <IconaLogo class="fit__img" />
        </div>
      </div>
      <br />
      <br />
      <div class="row pt-2">
        <b-overlay
          :show="loading"
          rounded="sm"
          spinner-variant="secondary"
          class="col-md-11 col-lg-10 mx-auto"
        >
          <conversazione :destinatario="consulto.professionista" />
        </b-overlay>
      </div>
    </div>
    <div v-else>
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import IconaLogo from "@/../public/svg/icona.svg";
import ArrowLeftLogo from "@/../public/svg/arrow_left.svg";
import Conversazione from "@/components/Conversazione";
export default {
  name: "AvvioConsultoPaziente",
  components: { IconaLogo, Conversazione, ArrowLeftLogo },
  data() {
    return {
      consulto: null,
      loading: false,
      channel: null,
      name: null,
      started: false,
      showStartBtn: false,
      confirmed: false,
      minutesLefts: 0,
      intervalF: null
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    }
  },
  watch: {
    confirmed: function(val) {
      if (val) {
        this.checkPermission();
      }
    },
    minutesLefts: function(value) {
      if (value < 0) {
        // console.log("there is a countdown");
        var self = this;
        this.intervalF = setInterval(function() {
          self.checkPermission();
        }, 10000);
      }
      if (value >= 0) {
        // console.log("countdown ended");
        clearInterval(this.intervalF);
      }
    }
  },
  methods: {
    fetchData() {
      var url =
        process.env.VUE_APP_VERSION + "consulto/" + this.$route.params.rif;

      this.$axios
        .get(url)
        .then(res => {
          this.consulto = res.data.data;
          this.loading = false;
          this.confirmed = this.consulto.confirmed;
          this.minutesLefts = 0;
          // this.checkPermission();
        })
        .catch(err => {
          // console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    checkPermission() {
      var start = moment(this.consulto.data_inizio);
      var end = moment(this.consulto.data_fine);
      var now = moment();
      if (now.isAfter(start) && now.isBefore(end)) {
        this.showStartBtn = true;
      } else {
        var countDown = moment().add(15, "minutes");
        // console.log("countdown", countDown);
        if (countDown.isAfter(start) && countDown.isBefore(end)) {
          now.diff(start);
          this.minutesLefts = now.diff(start, "minutes") - 1;
        }
      }
    },
    start() {
      var url =
        process.env.VUE_APP_VERSION +
        "videochiamata/consulto/" +
        this.consulto.hashid;

      this.$axios
        .get(url)
        .then(res => {
          // console.log(res.data.data);
          if (res.data.data) {
            this.$router.push({
              name: "VideoConferenza",
              params: { hash: res.data.data.hashid, type: "paziente" }
            });
          }
        })
        .catch(err => {
          // console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
      // var url = process.env.VUE_APP_VERSION + "videochiamata";
      // var data = { consulto: this.consulto.hashid };

      // this.$axios
      //   .post(url, data)
      //   .then((res) => {
      //     console.log(res.data.data);
      //     if (res.data.data) {
      //       this.$router.push({
      //         name: "VideoConferenza",
      //         params: { hash: res.data.data.hashid, type: "paziente" },
      //       });
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     if (err.response.status === 401) {
      //       this.$router.go();
      //     }
      //   });
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {}
};
</script>
<style scoped>
.hidden__inputs {
  visibility: hidden;
}
</style>
